import {
  PartnerOptionDataUpdateRequest,
  PartnerOptionDatumService,
} from 'api-clients/monolith';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { addMessageAction } from 'containers/FlashMessage/actions';

export default function useDeletePartnerOptionData({
  successMessage,
  errorMessage,
}: {
  successMessage: string;
  errorMessage: string;
}) {
  const dispatch = useDispatch();
  const [isDeleting, setIsDeleting] = useState(false);

  const deletePartnerOptionData = async ({
    applicantId,
    partnerOptionDataId,
    fields,
  }: {
    applicantId: string;
    partnerOptionDataId: string;
    fields: PartnerOptionDataUpdateRequest;
  }) => {
    setIsDeleting(true);

    try {
      await PartnerOptionDatumService.deleteInternalApiApplicantsPartnerOptionData(
        applicantId,
        partnerOptionDataId,
        { fields },
      );

      dispatch(addMessageAction(successMessage, 'success'));
    } catch (e) {
      dispatch(addMessageAction(errorMessage, 'error'));
    } finally {
      setIsDeleting(false);
    }
  };

  return { deletePartnerOptionData, isDeleting };
}
